import TranslatedLink from './TranslatedLink';
export default TranslatedLink;
